export default __webpack_public_path__ + "static/media/js.84d25f20.png";